import Papa from 'papaparse';

import { ProjectFileUploadOptions } from 'src/store/state/projects';

export const unparseCsv = ({
  fields,
  rows,
  fileOptions,
}: {
  fields: string[];
  rows: string[][];
  fileOptions: ProjectFileUploadOptions;
}) => {
  return Papa.unparse(
    {
      fields,
      data: rows,
    },
    {
      delimiter: fileOptions.separator,
      escapeChar: fileOptions.escape,
      header: fileOptions.header,
      quoteChar: fileOptions.quote,
    }
  );
};
